export const coverageCheckerContent = {
  checkCoverageLabel: 'Check your coverage',
  poweredByText: ', powered by',
  poweredByLogoAlt: 'VodafoneThree',
}
